export const ALL_WAZE_SUBTYPES = [
  {
    name: 'ACCIDENT-low',
    value: '/assets/cartografia/accident-low.svg'
  },
  {
    name: 'WEATHERHAZARD-low',
    value: '/assets/cartografia/hazard-low.svg'
  },
  {
    name: 'CONSTRUCTION-low',
    value: '/assets/cartografia/construction-low.svg'
  },
  {
    name: 'ROAD_CLOSED-low',
    value: '/assets/cartografia/road_closed-low.svg'
  },
  {
    name: 'ACCIDENT-medium',
    value: '/assets/cartografia/accident-medium.svg'
  },
  {
    name: 'WEATHERHAZARD-medium',
    value: '/assets/cartografia/hazard-medium.svg'
  },
  {
    name: 'CONSTRUCTION-medium',
    value: '/assets/cartografia/construction-medium.svg'
  },
  {
    name: 'ROAD_CLOSED-medium',
    value: '/assets/cartografia/road_closed-medium.svg'
  },
  {
    name: 'ACCIDENT-high',
    value: '/assets/cartografia/accident-high.svg'
  },
  {
    name: 'WEATHERHAZARD-high',
    value: '/assets/cartografia/hazard-high.svg'
  },
  {
    name: 'CONSTRUCTION-high',
    value: '/assets/cartografia/construction-high.svg'
  },
  {
    name: 'ROAD_CLOSED-high',
    value: '/assets/cartografia/road_closed-high.svg'
  }
]



// WEBPACK FOOTER //
// ./src/app/common/waze-subtypes.ts